<template>
  <div>
    <div ref="campsiteTermsAndConditions" v-thtml="termsAndConditions" />
    <lazy-google-translate-button
      v-if="needsTranslation"
      :parent="campsiteTermsAndConditionsRef"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import VueHooksInfoMixin from '~/mixins/VueHooksInfoMixin'

@Component({
  mixins: [VueHooksInfoMixin],
})
class CampsiteTermsAndConditions extends Vue {
  @Prop()
  termsAndConditions: string

  @Prop({ default: false })
  needsTranslation: boolean

  get campsiteTermsAndConditionsRef() {
    // refs are not reactive, so need this little trick to make sure it's there when needed
    if (!this.isMounted) return undefined
    return this.$refs.campsiteTermsAndConditions as Element
  }
}

export default toNative(CampsiteTermsAndConditions)
</script>

<style scoped>
div :deep(.translation-text) {
  margin: 1em 0 1em !important;
}
</style>
